import { Injectable, Inject } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import * as _ from 'lodash';
import { StructureOrganizative } from '../models/structure-organizative.model';
import { Router } from '@angular/router';
import { CacheService } from './cache.service';

@Injectable({
   providedIn: "root"
})
export class StructureOrganizativeService {
   constructor(private http: HttpClient, @Inject("environment") private environment: any, private router: Router, private cacheService: CacheService) { }

   className = 'StructureOrganizativeService';

   getAllSO(cache = true): Observable<StructureOrganizative[]> {
      let cacheKey = "allSO"
      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey);
      } else {
         let observable = this.http.get<StructureOrganizative[]>(this.environment.base_URL + "/structure-organizative").pipe(map((res) => {
            this.cacheService.updateCacheData(res, cacheKey)
            return res;
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
      }
   }

   getAllSONoAutoID(): Observable<StructureOrganizative[]> {
      return this.http
         .get<StructureOrganizative[]>(this.environment.base_URL + "/structure-organizative")
         .pipe(map<StructureOrganizative[], StructureOrganizative[]>(res => this.removeById(res)));
   }

   newSO(structure) {
      return this.http.post(this.environment.base_URL + "/structure-organizative", structure);
   }

   editSO(structure) {
      return this.http.put(this.environment.base_URL + `/structure-organizative`, structure);
   }

   removeById(array) {
      console.log("removeById", array)
      array.forEach(element => {
         delete element.id;
      });
      return array;
   }

   mapDeepAndFlatted(array) {
      let flattedSO = []
      _.forEach(array, (d) => {
         flattedSO.push(d);
         flattedSO = flattedSO.concat(this.getChildrenSO(d));
      })
      return _.uniqBy(flattedSO, 'idOrganizationalStructurePk');
   }

   getChildrenSO(SO) {
      let childrenSO = [];
      if (_.get(SO, 'organizationalStructure')) {
         childrenSO.push(_.get(SO, 'organizationalStructure'));
         childrenSO = childrenSO.concat(this.getChildrenSO(_.get(SO, 'organizationalStructure')))
      }
      return childrenSO;
   }
}
